// This is a generated file!
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const _define = require("../../define");
const iconSkTemplate = document.createElement('template');
iconSkTemplate.innerHTML = '<svg class="icon-sk-svg" xmlns="http://www.w3.org/2000/svg" width=24 height=24 viewBox="0 0 24 24"><path d="M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z"/></svg>';
(0, _define.define)('autorenew-icon-sk', class extends HTMLElement {
    connectedCallback() {
        const icon = iconSkTemplate.content.cloneNode(true);
        while(this.firstChild){
            this.removeChild(this.firstChild);
        }
        this.appendChild(icon);
    }
});
